import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {validateAllFormFields} from '../../../utils/form.utils';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {AuthService, UserService} from '../../../../core/services';
import {UserModel} from '../../../../core/models';
import {take} from 'rxjs/operators';

@Component({
  selector: 'app-contact-dialog',
  templateUrl: './contact-dialog.component.html',
  styleUrls: ['./contact-dialog.component.css']
})
export class ContactDialogComponent implements OnInit {
  contactForm: FormGroup;
  user: UserModel = {} as UserModel;
  isAuthenticated: boolean;
  loading = false;
  submitted = false;
  clickFrom: string;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) private data: { context: string },
    public dialogRef: MatDialogRef<ContactDialogComponent>) {
    this.contactForm = this.fb.group({
      subject: ['', Validators.required],
      body: ['', Validators.required],
    });
    this.clickFrom = data.context;
  }

  ngOnInit() {
    this.authService.isAuthenticated.pipe(take(1)).subscribe(
      (isAuthenticated) => {
        this.isAuthenticated = isAuthenticated;
        if (!isAuthenticated) {
          this.contactForm.addControl('name', new FormControl('', [Validators.required]));
          this.contactForm.addControl('company', new FormControl('', [Validators.required]));
          this.contactForm.addControl('email', new FormControl('', [Validators.required, Validators.email]));
          this.contactForm.addControl(
            'phone',
            new FormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]));
          this.contactForm.get('subject').setValue('עזרה משתמש לא רשום');
          this.contactForm.get('body').setValue('עזרה משתמש לא רשום');
        }
      }
    );

    this.authService.currentUser.pipe(take(1)).subscribe( user => {
      if (user.name) {
        this.user = user;
      }
    });
  }

  submit() {
    if (this.contactForm.invalid) {
      validateAllFormFields(this.contactForm);
      return;
    }
    this.loading = true;
    let msg = this.contactForm.value;
    if (this.isAuthenticated) {
      msg.name = this.user.username + ' - ' + this.user.name;
      msg.company = this.user.name;
      msg.email = this.user.email;
      msg.phone = this.user.phone;
    }
    this.userService.support(msg).subscribe( res => {
      this.loading = false;
      this.submitted = true;
      window.dataLayer.push({
        event: 'lead form',
        eventCategory: 'lead form',
        eventAction: this.clickFrom,
      });
    });
  }

  close() {
    this.dialogRef.close();
  }

}
